import * as React from 'react';
import { NoWrapParagraph } from '../../../components/cirium/NoWrapParagraph';
import { CiriumModal } from '../../../components/cirium/CiriumModal';
import { Button, Flex } from '@flightstats/airframe-react';

export type ResetPasswordModalProps = {
  showModal: boolean;
  confirmSuccess: () => void;
  email: string;
};

export const ResetPasswordModal: React.FC<ResetPasswordModalProps> = ({
  showModal,
  confirmSuccess,
  email,
}) => (
  <CiriumModal showModal={showModal} title="Reset Password" aria-labelledby="reset-password-modal-title">
    <Flex className='reset-modal-flex'>
      <NoWrapParagraph className='no-wrap-para'>
        The username and a new password have been sent to{' '}
      </NoWrapParagraph>
      <NoWrapParagraph bold inline>
        {email}
      </NoWrapParagraph>
      <Button className='reset-password-button' onClick={confirmSuccess} aria-label="Confirm">
        OK
      </Button>
    </Flex>
  </CiriumModal>
);

export default ResetPasswordModal;